module.exports = __webpack_public_path__ + "img/bond.4c952d60.svg";